'use strict';

(function () {
    'use strict';

    angular.module('zp').directive('searchAddress', searchAddress);

    /** @ngInject */
    function searchAddress(GooglePlacesConfig) {
        return {
            restrict: 'E',
            link: link,
            transclude: true,
            replace: true,
            scope: {
                addressChange: '=',
                addressPlaceholder: '=',
                geolocationModel: '=',
                hideIcon: '&?',
                defaultEmpty: '&?',
                addressName: '=?'
            },
            templateUrl: 'app/results/filters/search.address.html'
        };

        function link(scope, element, attributes) {

            scope.onAddressChange = onAddressChange;
            scope.defaultEmpty = scope.defaultEmpty ? true : false;
            scope.addressModel = null; //scope.defaultEmpty ? null : scope.addressPlaceholder;
            scope.addressOptions = GooglePlacesConfig.to;
            scope.hideIcon = scope.hideIcon ? scope.hideIcon : false;
            scope.addressName = scope.addressName ? scope.addressName : scope.addressPlaceholder;

            ///////////////////////////////////////////////////

            (function activate() {
                // scope.$watch('addressPlaceholder', function(newValue, oldValue) {
                //     scope.addressModel = newValue;
                // });
            })();

            ///////////////////////////////////////////////////

            function onAddressChange() {
                if (!!scope.addressModel && scope.addressModel.formatted_address) {
                    scope.geolocationModel.address = scope.addressModel.formatted_address;
                    scope.geolocationModel.latitude = scope.addressModel.geometry.location.lat();
                    scope.geolocationModel.longitude = scope.addressModel.geometry.location.lng();
                    var cityComponent = findAddressComponentByType('locality');
                    scope.geolocationModel.city = cityComponent ? cityComponent.long_name : '';
                    var countryComponent = findAddressComponentByType('country');
                    scope.geolocationModel.country = countryComponent ? countryComponent.long_name : '';
                } else {
                    scope.geolocationModel.address = scope.addressModel;
                    scope.geolocationModel.latitude = null;
                    scope.geolocationModel.longitude = null;
                }
                if (!!scope.addressChange) {
                    scope.addressChange();
                }
            }

            function findAddressComponentByType(type) {
                if (!scope.addressModel || !scope.addressModel.formatted_address) {
                    return null;
                }
                for (var i = 0; i < scope.addressModel.address_components.length; i++) {
                    if (scope.addressModel.address_components[i].types[0] == type) {
                        return scope.addressModel.address_components[i];
                    }
                }
                return null;
            }
        }
    }
})();